function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

class CustomFilters extends HTMLElement {
  constructor() {
    super();

    this.modal = this.querySelector('.custom-filters__modal');
    this.overlay = this.querySelector('.custom-filters__overlay');
    this.loader = this.querySelector('.custom-filters__loader');
    this.filterForm = this.querySelector('form');
    this.openBtn = this.querySelector('.custom-filters__button');
    this.closeBtn = this.querySelector('.custom-filters__close');
  }

  connectedCallback() {
    if (this.filterForm) this.filterForm.addEventListener('input', debounce(this.onSubmitHandler.bind(this), 800));
    if (this.openBtn) this.openBtn.addEventListener('click', () => this.open());
    if (this.closeBtn) this.closeBtn.addEventListener('click', () => this.close());
    if (this.overlay) this.overlay.addEventListener('click', () => this.close());
  }

  open() {
    this.modal?.setAttribute('aria-hidden', 'false');
    this.overlay?.setAttribute('aria-hidden', 'false');
  }

  close() {
    this.modal?.setAttribute('aria-hidden', 'true');
    this.overlay?.setAttribute('aria-hidden', 'true');
  }

  renderPage(searchParams) {
    this.searchParamsPrev = searchParams;
    const sectionId = this.getSectionId();

    this.loader.setAttribute('aria-hidden', 'false');

    const url = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;
    this.updateURLHash(searchParams);
    fetch(url)
      .then((response) => response.text())
      .then((html) => {
        this.renderContent(html);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => {
        this.loader.setAttribute('aria-hidden', 'true');
      });
  }

  renderContent(html) {
    const template = document.createElement('template');
    template.innerHTML = html;

    const selectors = ['.collection-listing', '#CustomFiltersButton', '.facets__summary-label', '.js-filters'];
    for (const selector of selectors) {
      const newElements = template.content.querySelectorAll(selector);
      const currentElements = document.querySelectorAll(selector);
      console.log(newElements, currentElements);
      if (newElements.length > 0) {
        currentElements.forEach((currentElement, index) => {
          if (currentElements[index]) {
            currentElements[index].innerHTML = newElements[index].innerHTML;
          }
        });
      }
    }
  }

  updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}?${searchParams}`);
  }

  getSectionId() {
    return this.closest('[data-section-id]').dataset.sectionId;
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    const searchParams = new URLSearchParams();
    formData.forEach((value, key) => {
      if (!value) return;
      searchParams.append(key, value);
    });
    return searchParams;
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const form = event.target.closest('form');
    const searchParams = this.createSearchParams(form);
    this.renderPage(searchParams.toString());
  }
}

customElements.define('custom-filters', CustomFilters);
